<app-nav></app-nav>
<app-top-header
  [showMonthControl]="false"
  [pageTitle]="'page.dashboard'"
  [showPageInfoButton]="true"
  (pageInfoClick)="toggleDashboardInfo()"
></app-top-header>

<div class="dashboard-wrapper">
  <div class="dashboard-shell">
    <div class="dashboard-message error" *ngIf="!isLoading && error">{{ error }}</div>

    <ng-container>
      <div class="dashboard-info-overlay" *ngIf="showDashboardInfo" (click)="closeDashboardInfo()">
        <div class="dashboard-info-popover" (click)="$event.stopPropagation()">
          <div class="dashboard-info-title-row">
            <div class="dashboard-info-title">{{ 'dashboard.guideTitle' | t }}</div>
            <button type="button" class="dashboard-info-close" (click)="closeDashboardInfo()" [attr.aria-label]="'common.close' | t">&times;</button>
          </div>

          <div class="dashboard-info-section">
            <h4>{{ 'dashboard.guideMonthTitle' | t }} ({{ pendingMonthLabel }})</h4>
            <p>{{ 'dashboard.guideMonthIntro' | t }}</p>
            <ul>
              <li>{{ 'dashboard.guideMonthItemCollection' | t }}</li>
              <li>{{ 'dashboard.guideMonthItemExpense' | t }}</li>
              <li>{{ 'dashboard.guideMonthItemNet' | t }}</li>
              <li>{{ 'dashboard.guideMonthItemPending' | t }}</li>
              <li>{{ 'dashboard.guideMonthItemPendingList' | t }}</li>
            </ul>
          </div>

          <div class="dashboard-info-section">
            <h4>{{ 'dashboard.guideSummaryTitle' | t }}</h4>
            <p>{{ 'dashboard.guideSummaryIntro' | t }}</p>
            <ul>
              <li>{{ 'dashboard.guideSummaryItemOff' | t }}</li>
              <li>{{ 'dashboard.guideSummaryItemOn' | t }}</li>
              <li>{{ 'dashboard.guideSummaryItemExpense' | t }}</li>
              <li>{{ 'dashboard.guideSummaryItemNet' | t }}</li>
              <li>{{ 'dashboard.guideSummaryItemPending' | t }}</li>
            </ul>
          </div>

          <div class="dashboard-info-section">
            <h4>{{ 'dashboard.guidePendingTitle' | t }}</h4>
            <p>{{ 'dashboard.guidePendingIntro' | t }}</p>
            <ul>
              <li>{{ 'dashboard.guidePendingItemFilter' | t }}</li>
              <li>{{ 'dashboard.guidePendingItemClick' | t }}</li>
              <li>{{ 'dashboard.guidePendingItemAddPayment' | t }}</li>
            </ul>
          </div>

          <div class="dashboard-info-section">
            <h4>{{ 'dashboard.guideYearlyTitle' | t }}</h4>
            <p>{{ 'dashboard.guideYearlyIntro' | t }}</p>
            <p>{{ 'dashboard.guideYearlySummary' | t }}</p>
            <ul>
              <li>{{ 'dashboard.guideYearlyItemOff' | t }}</li>
              <li>{{ 'dashboard.guideYearlyItemOn' | t }}</li>
              <li>{{ 'dashboard.guideYearlyItemClick' | t }}</li>
              <li>{{ 'dashboard.guideYearlyItemAdvance' | t }}</li>
            </ul>
          </div>

          <div class="dashboard-info-section">
            <h4>{{ 'dashboard.guideSnapshotTitle' | t }}</h4>
            <p>{{ 'dashboard.guideSnapshotIntro' | t }}</p>
            <ul>
              <li>{{ 'dashboard.house' | t }}</li>
              <li>{{ 'dashboard.flat' | t }}</li>
              <li>{{ 'dashboard.totalRenter' | t }}</li>
              <li>{{ 'dashboard.availableRenter' | t }}</li>
              <li>{{ 'dashboard.availableFlats' | t }}</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="pending-month-row">
        <div class="pending-month-nav">
          <button type="button" class="pending-nav-btn" (click)="previousPendingMonth()">&lsaquo;</button>
          <span>{{ pendingMonthLabel }}</span>
          <button
            type="button"
            class="pending-nav-btn"
            [disabled]="isAtCurrentMonth"
            [class.disabled]="isAtCurrentMonth"
            (click)="nextPendingMonth()"
          >&rsaquo;</button>
        </div>
      </div>

      <div class="dashboard-main-grid">
        <div class="dashboard-left-stack">
          <section class="panel monthly-summary-panel">
            <header class="panel-header">
              <h2>{{ 'dashboard.monthlySummary' | t }}</h2>
            </header>
            <app-content-skeleton
              *ngIf="isLoading"
              variant="stats"
              [count]="4"
            ></app-content-skeleton>
            <div class="summary-grid" *ngIf="!isLoading">
              <article class="summary-card primary">
                <div class="label">{{ 'dashboard.collectionPayment' | t }}<span *ngIf="pendingCollectionRangeShortLabel"> ({{ pendingCollectionRangeShortLabel }})</span></div>
                <div class="value">{{ formatAmount(collectionAmount) }}</div>
                <div class="meta">{{ collectionRows }} {{ 'dashboard.transactions' | t }}</div>
              </article>

              <article class="summary-card">
                <div class="label">{{ 'dashboard.metric.expense' | t }}</div>
                <div class="value">{{ formatAmount(expenseAmount) }}</div>
                <div class="meta">{{ expenseRows }} {{ 'dashboard.expenseCount' | t }}</div>
              </article>

              <article class="summary-card">
                <div class="label">{{ 'dashboard.netCollection' | t }}</div>
                <div class="value">{{ formatAmount(netCollection) }}</div>
                <div class="meta">{{ 'dashboard.collectionMinusExpense' | t }}</div>
              </article>

              <article class="summary-card warning">
                <div class="label">{{ 'dashboard.pendingCollection' | t }}<span *ngIf="pendingCollectionRangeShortLabel"> ({{ pendingCollectionRangeShortLabel }})</span></div>
                <div class="value">{{ formatAmount(dueAmount) }}</div>
                <div class="meta">{{ 'dashboard.pendingAmountForDisplayedRange' | t }}</div>
              </article>
            </div>
          </section>

          <div class="rent-only-row">
            <label class="rent-only-switch">
              <input type="checkbox" [(ngModel)]="isHouseRentOnly" (ngModelChange)="onHouseRentOnlyToggle()">
              <span class="rent-only-slider" aria-hidden="true"></span>
              <span class="rent-only-label">{{ 'dashboard.rentOnly' | t }}</span>
            </label>
          </div>

          <section class="panel chart-panel">
          <header class="panel-header chart-header">
            <div class="chart-header-top">
              <div class="yearly-header-text">
                <h2>{{ 'dashboard.yearly' | t }} {{ yearlyMetricLabel | t }} ({{ yearlyGraphYear }})</h2>
              </div>
              <button
                type="button"
                class="yearly-report-btn"
                [class.active]="canOpenYearlyReport"
                (click)="onYearlyReportButtonClick()"
              >{{ 'dashboard.report' | t }}</button>
            </div>
            <div class="yearly-controls">
              <div class="yearly-control-item yearly-control-item-small">
                <app-common-dropdown
                  [compact]="true"
                  [dropdownObj]="{
                    name: 'yearlyGraphYear',
                    label: 'topHeader.year',
                    placeholder: 'placeholder.selectYear',
                    valueKey: 'value',
                    display1: 'label',
                    isSearchable: true,
                    options: yearlyGraphYearOptions
                  }"
                  [value]="yearlyGraphYear"
                  (valueChange)="onYearlyDropdownChange($event)"
                ></app-common-dropdown>
              </div>
              <div class="yearly-control-item yearly-control-item-small">
                <app-common-dropdown
                  [compact]="true"
                  [dropdownObj]="{
                    name: 'yearlyMetric',
                    label: 'dashboard.type',
                    placeholder: 'dashboard.selectType',
                    valueKey: 'value',
                    display1: 'label',
                    isSearchable: true,
                    searchReadonly: true,
                    options: yearlyMetricOptions
                  }"
                  [value]="yearlyMetric"
                  (valueChange)="onYearlyDropdownChange($event)"
                ></app-common-dropdown>
              </div>
              <div class="yearly-control-item yearly-control-item-wide">
                <app-common-dropdown
                  [compact]="true"
                  [dropdownObj]="{
                    name: 'yearlyHouseId',
                    label: 'filter.house',
                    placeholder: 'placeholder.selectHouse',
                    apiInfo: 'HOUSE_LIST',
                    valueKey: 'id',
                    display1: 'houseName',
                    display2: 'houseAddress',
                    isSearchable: true,
                    status: 1
                  }"
                  [value]="yearlyHouseId"
                  (valueChange)="onYearlyDropdownChange($event)"
                ></app-common-dropdown>
              </div>
              <div class="yearly-control-item yearly-control-item-wide">
                <app-common-dropdown
                  [compact]="true"
                  [dropdownObj]="{
                    name: 'yearlyFlatId',
                    label: 'filter.flat',
                    placeholder: 'placeholder.selectFlat',
                    apiInfo: 'FLAT_LIST',
                    valueKey: 'id',
                    display1: 'flatName',
                    display2: 'floorName',
                    isSearchable: true,
                    status: 1
                  }"
                  [requestFilters]="yearlyHouseId ? {'house.id': yearlyHouseId} : null"
                  [value]="yearlyFlatId"
                  (valueChange)="onYearlyDropdownChange($event)"
                ></app-common-dropdown>
              </div>
            </div>
          </header>
          <app-content-skeleton
            *ngIf="isYearlyLoading"
            variant="chart"
            [count]="12"
          ></app-content-skeleton>
          <div class="bar-chart" *ngIf="!isYearlyLoading">
            <div class="bar-item" *ngFor="let value of yearlySeries; let i = index">
              <div class="bar-value">{{ formatAmount(value) }}</div>
              <div class="bar-track clickable" (click)="openYearlyBreakdown(i)" [class.disabled]="value <= 0">
                <div class="bar-fill" [class.zero]="value <= 0" [style.height.%]="barHeight(value)"></div>
              </div>
              <div class="bar-label">{{ monthNames[i] }}</div>
            </div>
          </div>
          <div class="yearly-chart-footer" *ngIf="!isYearlyLoading">
            <span class="yearly-total">{{ 'dashboard.total' | t }}: {{ formatAmount(yearlyTotalAmount) }}</span>
          </div>
          </section>
        </div>

        <section class="panel recent-panel pending-collection-panel">
          <header class="panel-header">
            <h2>{{ 'dashboard.pendingCollection' | t }}<span *ngIf="pendingCollectionRangeShortLabel"> ({{ pendingCollectionRangeShortLabel }})</span></h2>
            <div class="pending-header-actions">
              <span class="panel-total-count">{{ 'dashboard.totalEntries' | t }}: {{ monthlyPendingRows.length }}</span>
            </div>
          </header>
          <div class="pending-filter-row">
            <app-common-dropdown
              [compact]="true"
              [dropdownObj]="{
                name: 'pendingHouse',
                label: 'filter.house',
                placeholder: 'dashboard.allHouses',
                valueKey: 'value',
                display1: 'label',
                isSearchable: true,
                options: pendingHouseDropdownOptions
              }"
              [value]="pendingFilterHouse || null"
              (valueChange)="onPendingDropdownFilterChange($event)"
            ></app-common-dropdown>
            <app-common-dropdown
              [compact]="true"
              [dropdownObj]="{
                name: 'pendingFloor',
                label: 'filter.floor',
                placeholder: 'dashboard.allFloors',
                valueKey: 'value',
                display1: 'label',
                isSearchable: true,
                options: pendingFloorDropdownOptions
              }"
              [value]="pendingFilterFloor || null"
              (valueChange)="onPendingDropdownFilterChange($event)"
            ></app-common-dropdown>
            <app-common-dropdown
              [compact]="true"
              [dropdownObj]="{
                name: 'pendingFlat',
                label: 'filter.flat',
                placeholder: 'dashboard.allFlats',
                valueKey: 'value',
                display1: 'label',
                isSearchable: true,
                options: pendingFlatDropdownOptions
              }"
              [value]="pendingFilterFlat || null"
              (valueChange)="onPendingDropdownFilterChange($event)"
            ></app-common-dropdown>
          </div>
          <app-content-skeleton
            *ngIf="isPendingLoading"
            variant="table"
            [columns]="3"
            [rows]="7"
          ></app-content-skeleton>
          <div class="recent-empty" *ngIf="!isPendingLoading && monthlyPendingRows.length === 0">{{ 'dashboard.noPendingData' | t }}</div>
          <div class="recent-empty" *ngIf="!isPendingLoading && monthlyPendingRows.length > 0 && filteredMonthlyPendingRows.length === 0">{{ 'dashboard.noRowsMatch' | t }}</div>
          <div class="pending-list-wrap" *ngIf="!isPendingLoading && filteredMonthlyPendingRows.length > 0">
            <div class="pending-list-head">
              <span>{{ 'dashboard.flat' | t }}</span>
              <span class="pending-head-month">{{ 'dashboard.month' | t }}</span>
              <span class="pending-head-amount">{{ 'dashboard.amount' | t }}</span>
            </div>
            <div class="pending-list-cards" (scroll)="onPendingListScroll($event)">
              <article
                class="pending-card clickable"
                *ngFor="let item of visibleFilteredMonthlyPendingRows; let i = index"
                [class.alt]="i % 2 === 1"
                (click)="openPendingDetails(item)"
              >
                <span class="pending-cell-flat">
                  <strong>{{ item.flat }}</strong>
                  <small>{{ item.house }} | {{ item.floor }}</small>
                </span>
                <span class="pending-cell-month">{{ item.month }}</span>
                <span class="pending-cell-amount" [class.amount-zero]="item.amount <= 0">{{ formatAmount(item.amount) }}</span>
              </article>
            </div>
          </div>
        </section>
      </div>

      <section class="active-snapshot-panel bottom-snapshot-panel">
        <app-content-skeleton
          *ngIf="isSnapshotLoading"
          variant="pills"
          [count]="5"
        ></app-content-skeleton>
        <div class="entity-grid" *ngIf="!isSnapshotLoading">
          <div class="entity-pill">{{ 'dashboard.house' | t }}: <strong>{{ houseCount }}</strong></div>
          <div class="entity-pill">{{ 'dashboard.flat' | t }}: <strong>{{ flatCount }}</strong></div>
          <div class="entity-pill">{{ 'dashboard.totalRenter' | t }}: <strong>{{ totalRenterCount }}</strong></div>
          <button type="button" class="entity-pill entity-pill-button" (click)="openAvailableRenterModal()">
            {{ 'dashboard.availableRenter' | t }}: <strong [class.available-count-alert]="availableRenterCount > 0">{{ availableRenterCount }}</strong>
          </button>
          <button type="button" class="entity-pill entity-pill-button" (click)="openAvailableFlatModal()">
            {{ 'dashboard.availableFlats' | t }}: <strong [class.available-count-alert]="availableFlatCount > 0">{{ availableFlatCount }}</strong>
          </button>
        </div>
      </section>

      <div class="snapshot-modal-overlay" *ngIf="isSnapshotModalOpen" (click)="closeSnapshotModal()">
        <div class="snapshot-modal history-modal" (click)="$event.stopPropagation()">
          <button class="snapshot-close" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeSnapshotModal()">&times;</button>
          <h3>{{ snapshotModalTitle }}</h3>
          <div class="history-subtitle">
            {{ 'dashboard.total' | t:'Total' }}: {{ snapshotModalCount }}
          </div>

          <ng-container *ngIf="snapshotModalType === 'renters'">
            <div class="history-list snapshot-list" *ngIf="availableRenterRows.length > 0; else emptySnapshot">
              <div class="history-header snapshot-header renters">
                <span>Name</span>
                <span>Mobile</span>
                <span>Email</span>
                <span>Photo ID</span>
                <span>Action</span>
              </div>
              <div class="history-card snapshot-card renters" *ngFor="let renter of availableRenterRows">
                <span>{{ renter.name }}</span>
                <span>{{ renter.mobile }}</span>
                <span>{{ renter.email }}</span>
                <span>{{ renter.photoId }}</span>
                <span>
                  <button type="button" class="snapshot-row-action" (click)="openAssignFlatFromAvailableRenter(renter, $event)">Assign Flat</button>
                </span>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="snapshotModalType === 'flats'">
            <div class="history-list snapshot-list" *ngIf="availableFlatRows.length > 0; else emptySnapshot">
              <div class="history-header snapshot-header flats">
                <span>Flat</span>
                <span>House</span>
                <span>Floor</span>
                <span>Rent</span>
                <span>Pay Day</span>
                <span>Action</span>
              </div>
              <div class="history-card snapshot-card flats" *ngFor="let flat of availableFlatRows">
                <span>{{ flat.flat }}</span>
                <span>{{ flat.house }}</span>
                <span>{{ flat.floor }}</span>
                <span>{{ formatAmount(flat.rent) }}</span>
                <span>{{ flat.payDay }}</span>
                <span>
                  <button type="button" class="snapshot-row-action" (click)="openAssignRenterFromAvailableFlat(flat, $event)">Assign Renter</button>
                </span>
              </div>
            </div>
          </ng-container>

          <ng-template #emptySnapshot>
            <div class="dashboard-message">{{ snapshotModalEmptyMessage }}</div>
          </ng-template>

          <div class="snapshot-actions">
            <button type="button" class="snapshot-action-btn" (click)="closeSnapshotModal()">{{ 'common.close' | t:'Close' }}</button>
          </div>
        </div>
      </div>

      <app-new-edit-assign
        *ngIf="isSnapshotAssignOpen && (selectedSnapshotFlat || selectedSnapshotRenter)"
        [mode]="'create'"
        [initialMapping]="null"
        [preselectedFlat]="selectedSnapshotFlat"
        [preselectedRenter]="selectedSnapshotRenter"
        (close)="closeSnapshotAssignModal()"
        (save)="onSnapshotAssignSaved($event)"
      ></app-new-edit-assign>

      <app-detail-assign
        [visible]="isPendingDetailsOpen"
        [mapping]="selectedPendingMapping"
        [showAddPayment]="true"
        [addPaymentDisabled]="isPendingPaymentBlocked()"
        (addPayment)="openPaymentFromSelectedPendingMapping()"
        (addPaymentBlocked)="onBlockedPendingPaymentClick()"
        (close)="closePendingDetails()"
      ></app-detail-assign>

      <div class="yearly-breakdown-overlay" *ngIf="showYearlyBreakdownModal" (click)="closeYearlyBreakdown()">
        <div class="yearly-breakdown-modal" (click)="$event.stopPropagation()">
          <div class="yearly-breakdown-header">
            <div>
              <h3>{{ selectedYearlyBreakdownTitle }}</h3>
              <p>{{ yearlyMetric === 'expense' ? ('dashboard.breakdownExpense' | t) : ('dashboard.breakdownCollection' | t) }}</p>
            </div>
            <button type="button" class="yearly-breakdown-close" (click)="closeYearlyBreakdown()">&times;</button>
          </div>

          <div class="yearly-breakdown-body">
            <div class="yearly-breakdown-pie-wrap">
              <div class="yearly-breakdown-pie" [ngStyle]="selectedYearlyBreakdownPieStyle"></div>
              <div class="yearly-breakdown-total">
                <span>{{ 'dashboard.breakdownTotal' | t }}</span>
                <strong>{{ formatAmount(selectedYearlyBreakdownData.grandTotal) }}</strong>
              </div>
            </div>

            <div class="yearly-breakdown-legend">
              <div class="yearly-breakdown-row" *ngFor="let item of selectedYearlyBreakdownLegend">
                <span class="dot" [style.background]="item.color"></span>
                <span>{{ item.label }}</span>
                <strong>{{ formatAmount(item.value) }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-yearly-report-modal
        [visible]="isYearlyReportModalOpen"
        [year]="yearlyGraphYear"
        [metric]="yearlyMetric"
        [metricLabel]="yearlyMetricLabel"
        [houseLabel]="yearlyReportHouseLabel"
        [houseNo]="yearlyReportHouseNo"
      [houseAddress]="yearlyReportHouseAddress"
      [flatLabel]="yearlyReportFlatLabel"
      [floorLabel]="yearlyReportFloorLabel"
      [negativeChargeTitle]="yearlyReportNegativeChargeTitle"
      [brandName]="yearlyReportBrandName"
      [brandLogoUrl]="yearlyReportBrandLogoUrl"
      [generatedOn]="yearlyReportGeneratedOn"
      [generatedBy]="yearlyReportGeneratedBy"
      [developedBy]="yearlyReportDevelopedBy"
        [loading]="isYearlyReportLoading"
        [collectionRows]="yearlyReportCollectionRows"
        [expenseRows]="yearlyReportExpenseRows"
        [collectionTotalAmount]="yearlyReportTotalAmount"
        [expenseTotalAmount]="yearlyReportExpenseTotalAmount"
        (close)="closeYearlyReportModal()"
      ></app-yearly-report-modal>
    </ng-container>
  </div>
</div>

<app-make-payment
  *ngIf="isPendingPaymentModalOpen"
  [mode]="'create'"
  [initialPayment]="null"
  [prefillContext]="pendingPaymentPrefillContext"
  [receiptBrandName]="yearlyReportBrandName"
  [receiptBrandLogoUrl]="yearlyReportBrandLogoUrl"
  [closeAfterSuccessfulAction]="true"
  (close)="closePendingPaymentModal()"
  (save)="onPendingPaymentSaved($event)"
></app-make-payment>
